import { createApp, h } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { initialState } from "./store";
import Setinterval from "@/plugins/Setinterval";
import VueGtm from "vue-gtm";
import PerformanceMonitor from "@/utils/performance";

// Service Worker の強制更新（既存ユーザー対応）
const SW_VERSION = "2026-02-18-v1"; // デプロイ時に更新
(async function forceUpdateServiceWorker() {
  if ("serviceWorker" in navigator) {
    const lastVersion = localStorage.getItem("sw_version");

    // バージョンが変わった場合、全ての Service Worker を更新
    if (lastVersion !== SW_VERSION) {
      console.log(
        "🔄 Service Worker バージョン更新検出:",
        lastVersion,
        "→",
        SW_VERSION
      );

      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          // 更新をチェックして即座に適用
          await registration.update();
          if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
          }
        }
        localStorage.setItem("sw_version", SW_VERSION);
        console.log("✅ Service Worker 更新完了");
      } catch (error) {
        console.error("⚠️ Service Worker 更新エラー:", error);
      }
    }
  }
})();

const app = createApp({
  render: () => h(App),
  created() {
    // キャッシュされたAPIエンドポイントをチェック
    this.checkAndClearApiEndpointCache();
    localStorage.setItem("initialState", JSON.stringify(initialState));
  },
  methods: {
    checkAndClearApiEndpointCache() {
      try {
        const cached = localStorage.getItem("MOG");
        const currentEndpoint =
          process.env.VUE_APP_API_ENDPOINT || "https://stg-api.gama-mog.com";

        console.log("🔍 環境変数チェック:", {
          VUE_APP_API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
          currentEndpoint: currentEndpoint,
          nodeEnv: process.env.NODE_ENV,
        });

        if (cached) {
          const parsedCache = JSON.parse(cached);
          console.log("📦 現在のキャッシュ:", {
            cachedEndpoint: parsedCache.apiEndpoint,
            currentEndpoint: currentEndpoint,
          });

          // キャッシュされたエンドポイントが現在の設定と異なる場合は強制クリア
          if (
            parsedCache.apiEndpoint &&
            parsedCache.apiEndpoint !== currentEndpoint
          ) {
            console.warn(
              `🔄 APIエンドポイント変更検出: ${parsedCache.apiEndpoint} → ${currentEndpoint}`
            );
            console.warn("📦 Vuexキャッシュを強制クリアします...");

            // 完全にキャッシュをクリア
            localStorage.removeItem("MOG");
            localStorage.removeItem("initialState");

            console.log(
              "✅ APIエンドポイントキャッシュが完全にクリアされました"
            );

            // 強制リロード（オプション）
            if (
              confirm(
                "APIエンドポイントが変更されました。ページを再読み込みしますか？"
              )
            ) {
              window.location.reload();
            }
          } else {
            console.log("✅ APIエンドポイントは正常です:", currentEndpoint);
          }
        } else {
          console.log("📦 キャッシュは存在しません - 新規初期化");
        }

        // デバッグ用の手動キャッシュクリア関数を追加
        window.clearMOGCache = () => {
          localStorage.removeItem("MOG");
          localStorage.removeItem("initialState");
          console.log("🧹 手動キャッシュクリア完了");
          window.location.reload();
        };

        // 現在のAPIエンドポイントを確認する関数
        window.checkCurrentEndpoint = () => {
          const cached = localStorage.getItem("MOG");
          if (cached) {
            const parsedCache = JSON.parse(cached);
            console.log("📍 現在のエンドポイント:", {
              cached: parsedCache.apiEndpoint,
              env: process.env.VUE_APP_API_ENDPOINT || "未設定",
              fallback: "https://stg-api.gama-mog.com",
            });
          }
        };
      } catch (error) {
        console.error("⚠️ キャッシュチェック中にエラーが発生:", error);
        // エラーの場合はキャッシュをクリア
        localStorage.removeItem("MOG");
        localStorage.removeItem("initialState");
      }
    },
  },
});
app.use(router);
app.use(store);
app.use(VueGtm, {
  id: "GTM-TMLRH7R",
});
// app.use(createMetaManager());
app.use(Setinterval);

// パフォーマンス監視を有効化（開発環境のみ動作）
try {
  app.use(PerformanceMonitor);
  console.log("✅ パフォーマンス監視が有効化されました");
} catch (error) {
  console.error("⚠️ パフォーマンス監視の初期化エラー:", error);
}

// ビルド情報をコンソールに表示
console.group("🔧 ビルド情報");
console.log(
  "API Endpoint:",
  process.env.VUE_APP_API_ENDPOINT || "https://stg-api.gama-mog.com"
);
console.log("Environment:", process.env.VUE_APP_ENV || "development");
console.log("Build Mode:", process.env.NODE_ENV);
console.groupEnd();

// グローバルなキャッシュクリア機能をコンソールで利用可能にする
if (process.env.NODE_ENV === "development") {
  window.clearMOGCache = function () {
    console.group("🗑️ MOGキャッシュクリア");
    console.log("LocalStorageからMOGキャッシュを削除中...");
    localStorage.removeItem("MOG");
    localStorage.removeItem("initialState");
    console.log(
      "✅ キャッシュがクリアされました。ページをリロードしてください。"
    );
    console.groupEnd();
  };
  console.log(
    "💡 キャッシュクリア: window.clearMOGCache() をコンソールで実行してください"
  );
}

app.mount("#app");
